import { CommonModule } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'la-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, MatButtonModule, MatTooltipModule, MatIconModule],
})
export class IconButtonComponent {
  @Input({ required: true }) icon!: string;
  @Input({ transform: booleanAttribute }) outlined = true;
  @Input({ transform: booleanAttribute }) dense = false;
  @Input({ transform: booleanAttribute }) noFocus = false;
  @Input() disabled = false;
  @Input() color: 'normal' | 'warn' | 'primary' = 'normal';
  @Input() buttonLink?: string[] | string | null | undefined;

  @Input() tooltipForEnabled?: string;
  @Input() tooltipForDisabled?: string;
  @Input() tooltipPosition: 'above' | 'below' | 'left' | 'right' = 'below';

  @Output() action = new EventEmitter<PointerEvent>();

  get hasTooltip(): boolean {
    return !!this.tooltipForDisabled || !!this.tooltipForEnabled;
  }

  get tooltip(): string | undefined {
    return this.disabled ? this.tooltipForDisabled : this.tooltipForEnabled;
  }
}
